import React from 'react'

import { Form, Col } from '_zari/core'

const ImporteTotalFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='IMPORTE' htmlFor='input-importetotal-cuotas' md={12} />
      <Col md={12}>
        <Form.InputText disabled id='input-importetotal-cuotas' name='input-importetotal-cuotas' onChange={() => {}} value={value} />
      </Col>
    </Form.Group>
  )
}

export default React.memo(ImporteTotalFormGroup)
